export default "__VITE_ASSET__BvnzpfMU__"